import { Component, OnDestroy, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})

export class ProgressBarComponent implements OnDestroy {

  /**
   * @var Subscription
   */
  private valueSubscription: Subscription;

  /**
   * @var number
   */
  public currentValue = 0;

  /**
   * Der Maximale Wert, der in der Progressbar angezeigt werden soll
   *
   * @var number
   */
  public maxValue = 0;

  constructor(
    public modal: NgbActiveModal, public toast: ToastrService, public loading: LoadingService, public zone: NgZone
  ) {
    this.loading.setLoadingState(true);
  }

  ngOnDestroy() {
    if (this.valueSubscription) {
      this.valueSubscription.unsubscribe();
    }
  }

  /**
   * Setzt das Observable, mit welchem die Progressbar geupdatet werden soll
   *
   * @param observable
   */
  public setObservable = (observable: Observable<number>) => {
    this.valueSubscription = observable
      .subscribe(newValue => this.zone.run(() => {
        this.updateValue(newValue);
      }));

    this.loading.setLoadingState(false);
  }

  /**
   * Aktualisiert den Wert in der Klasse mit dem übergebenen Wert
   *
   * @param newValue
   */
  public updateValue = (newValue: number) => {
    this.currentValue = newValue;
    if (this.currentValue >= this.maxValue) {
      /**
       * Modal vor dem Schließen noch kurz offen lassen, damit man den
       * 100%-Status der Progress-Bar noch sehen kann. Sonst sieht es so aus,
       * als ob der Task nicht vollständig ausgeführt wurde.
       */
      setTimeout(() => {
        this.modal.close({ endProgress: true })
      }, 100);
    }

  }

  /**
   * Setzt den Maximalwert, der in der Progressbar dargestellt werden soll
   *
   * @param value
   */
  public setMaxValue = (value: number) => {
    this.maxValue = value;
  }
}
